// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__21KYC","title":"AfterFrontImage_title__1elj8"};